export function progress(state){
    return state.progress
}

export function search(state){
    return state.search
}

export function selected_areas(state){
    return state.selected_areas
}

export function presential_status(state){
    return state.presential_status
}

export function presential_is_online(state){
    return state.presential_is_online
}

export function selected_groups(state){
    return state.selected_groups
}

export function selected_tags(state){
    return state.selected_tags
}

export function loading(state){
    return state.loading
}